export default __webpack_public_path__ + "static/media/empatKosongEmpat.cd0df7f6.png";